import { useContext } from "react";
import { ComponentContext } from "./ComponentContext";

/**
 * `useComponentContext` is just a shorthand for `useContext(WebPartComponentContext)`.
 * @returns A context object that can be used by React components.
 */
export const useComponentContext = () => useContext(ComponentContext);